<section class="api-load-error card border-0">
  <div class="card-body d-flex flex-column align-items-center text-center">
    <div class="api-load-error__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" focusable="false">
        <path d="M12 3L22 21H2L12 3Z"></path>
        <rect x="11" y="8" width="2" height="7" rx="1"></rect>
        <circle cx="12" cy="18" r="1.2"></circle>
      </svg>
    </div>
    <h3 class="api-load-error__title mb-2">{{ title }}</h3>
    <p class="api-load-error__message mb-3">{{ message }}</p>
    <button class="btn btn-outline-primary" type="button" (click)="onRetry()">
      {{ retryLabel }}
    </button>
  </div>
</section>
